// pages/ErrorPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import EmptyHeader from '../../Components/Shared/EmptyHeader';
import AuthHeader from '../../Components/Account/AuthHeader';

const ErrorPage = ({ portalSettings }) => {
    //State Variables
    const navigate = useNavigate();

    //ENV Variables
    const companyName = import.meta.env.VITE_COMPANY_NAME;

    //Set Site Title
    document.title = `${companyName} - Error`;

    // If loading auth or no portal settings yet, just render nothing
    if (!portalSettings) return null;

    return (
        <>
            <EmptyHeader/>
            <div className="auth-container">
                <AuthHeader portalSettings={portalSettings} />
                <h2>Oops!</h2>
                <p>A server error occurred.</p>
                <p>A notification has automatically been sent to site maintenance.</p>
                <button className="baseButton" onClick={() => navigate('/')}>Back to Home</button>
            </div>
        </>
    );
};

export default ErrorPage;
